<div class="baselayer-control">
  @if (selectedBaselayer) {
    <button class="baselayer-thumb" [ngClass]="getClassName(selectedBaselayer.id)"
      [matTooltip]="'base-layer-selector.choose-baselayer' | translate" matTooltipPosition="after"
    (click)="toggle()"></button>
  }
</div>
<ng-template #baselayerPanel>
  <div class="baselayer-panel" (@openClose.start)="onAnimationEventStart($event)"
    (@openClose.done)="onAnimationEventEnd($event)" [@openClose]="isOpen() ? 'open' : 'close'">
    <mat-grid-list cols="1" rowHeight="1:1" gutterSize="3px">
      @for (layer of layerService.getBaseLayers(); track layer) {
        <mat-grid-tile>
          <button class="baselayer-thumb" [ngClass]="getClass(layer)" (click)="switchBaseLayer(layer.id)"
          [matTooltip]="layer.label" matTooltipPosition="after"></button>
        </mat-grid-tile>
      }
    </mat-grid-list>
  </div>
</ng-template>